import React, { useEffect, useState } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { ReservationModel, ReservationStatus } from '@/models/reservation';
import { apiClient } from '@/api/client';
import CountCard from '@/components/Common/CountCard';
import ReservationCard from '@/components/ReservationCard';
import GridContainer from '../../../@jumbo/components/GridContainer';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import { useDocumentTitle } from '@/hooks/use-document-title';

const useStyles = makeStyles((theme) => ({
	root: {
		paddingTop: 30,
		[theme.breakpoints.up('md')]: {
			paddingLeft: 50,
			paddingRight: 50,
		},
		[theme.breakpoints.up('lg')]: {
			paddingLeft: 65,
			paddingRight: 65,
		},
		[theme.breakpoints.up('xl')]: {
			paddingLeft: 88,
			paddingRight: 88,
		},
		[theme.breakpoints.down('sm')]: {
			paddingTop: 20,
			paddingBottom: 20,
		},
	},
	dashboardWrapper: {
		width: '100%',
		padding: '20px',
	},
	countCard: {
		backgroundColor: 'white',
	},
	captionReservation: {
		fontSize: '20px',
		marginTop: '30px',
		marginLeft: '30px',
	},
}));

const Dashboard = () => {
	const classes = useStyles();
	const [reservations, setReservations] = useState<ReservationModel[]>([]);

	useDocumentTitle('Dashboard');

	const [reservationsCount, setReservationsCount] = useState({
		arriving: 0,
		remaining: 0,
		completed: 0
	});

	useEffect(() => {
		async function fetchReservations() {
			try {
				const data = await apiClient.reservation.getTodaysReservations();
				const remainingReservations = data.filter(reservation => reservation.status !== ReservationStatus.STARTED);
				const completedReservations = data.filter(reservation => reservation.checkInDate !== null);
				const sortedReservations = data.sort((reservationA, reservationB) => reservationA.property!.name.localeCompare(reservationB.property!.name));

				setReservations(sortedReservations);

				setReservationsCount({
					arriving: data.length,
					remaining: remainingReservations.length,
					completed: completedReservations.length
				});
			} catch (error) {
				console.error(error);
			}
		}

		fetchReservations();
	}, []);

	return (
		<div className={classes.root}>
			<PageContainer heading="Daily Dashboard" breadcrumbs={[]}>
			<GridContainer className={classes.dashboardWrapper}>
				<CountCard
					value={reservationsCount.arriving}
					label='Arriving Reservations'
					className={classes.countCard}
				/>

				<CountCard
					value={reservationsCount.remaining}
					label='Remaining Arrivals'
					className={classes.countCard}
				/>

				<CountCard
					value={reservationsCount.completed}
					label='Completed check-in'
					className={classes.countCard}
				/>
			</GridContainer>

			<div style={{ display: 'grid', rowGap: '16px' }}>
				<h2>Today's arrivals</h2>

				{reservations.map((reservation) => (
					<ReservationCard
						key={reservation.id}
						reservation={reservation}
					/>
				))}
			</div>

		</PageContainer>
		</div>
	);
};

export default Dashboard;
